import { render, staticRenderFns } from "./OtherSupplierOrdersList.vue?vue&type=template&id=4bb22021&scoped=true&"
import script from "./OtherSupplierOrdersList.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./OtherSupplierOrdersList.vue?vue&type=style&index=0&id=4bb22021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb22021",
  null
  
)

export default component.exports